import { render } from "./navbar.vue?vue&type=template&id=c62d798e"
import script from "./navbar.vue?vue&type=script&lang=js"
export * from "./navbar.vue?vue&type=script&lang=js"
script.render = render

export default script